import { TableCell } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledHeaderTableCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#fafaff",
  borderRight: "1px solid #ebebf7",
  borderColor: "#ebebf7",

  [theme.breakpoints.down("xxl")]: {
    fontSize: 14,
    lineHeight: 1.4,
    padding: "8px 12px",
  },
  [theme.breakpoints.down("xl")]: {
    fontSize: 12,
    lineHeight: 1.3,
    padding: "6px 8px",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: 12,
    lineHeight: 1.2,
    padding: "4px 6px",
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderRight: "1px solid #ebebf7",
  borderColor: "#ebebf7",

  [theme.breakpoints.down("xxl")]: {
    fontSize: 14,
    lineHeight: 1.4,
    padding: "8px 12px",
  },
  [theme.breakpoints.down("xl")]: {
    fontSize: 12,
    lineHeight: 1.3,
    padding: "6px 8px",
  },
  [theme.breakpoints.down("lg")]: {
    fontSize: 12,
    lineHeight: 1.2,
    padding: "4px 6px",
  },
}));
